import Container from '@components/common/Container';
import { Background, Wrapper } from './Investors.styles';
import Link from '@components/common/Link';

export default function Investors() {
  return (
    <Background>
      <Container>
        <h2>Investors &amp; Partners</h2>
        <Wrapper>
          <Link href="https://shima.capital/" target="_blank" rel="noreferrer">
            <img src="/partners/shima.svg" alt="Shima Captial" height={38} />
          </Link>
          <Link href="https://hack.vc/" target="_blank" rel="noreferrer">
            <img src="/partners/hackvc.svg" alt="HackVC" height={34} />
          </Link>
          <Link href="https://bitscale.vc" target="_blank" rel="noreferrer">
            <img src="/partners/bitscale.svg" alt="Bitscale Captial" height={47} />
          </Link>
          <Link href="https://www.originprotocol.com/en/" target="_blank" rel="noreferrer">
            <img src="/partners/origin.svg" alt="Origin" height={30} />
          </Link>
          <Link href="https://halborn.com/" target="_blank" rel="noreferrer">
            <img src="/partners/halborn.svg" alt="Halborn" height={35} />
          </Link>
          <Link href="https://palsar.vc/" target="_blank" rel="noreferrer">
            <img src="/partners/palsar.svg" alt="Palsar" height={23} />
          </Link>
        </Wrapper>
      </Container>
    </Background>
  );
}
